import { consoleLogStyle, getSpm, getUuid } from './utils';
import type { JimoTrackerSdkData } from './type';

/**
 * 监听Body click, 比react事件提前执行
 */
export const createBodyClick = (ctx: any) => {
  document.body.addEventListener('click', (e: any) => {
    try {
      let target = e.target;
      const spmObj: any = {};
      while (target && target.dataset) {
        target.dataset.jtSpmb && (spmObj.pageDesc = target.dataset.jtSpmb);
        target.dataset.jtSpmc && (spmObj.blockDesc = target.dataset.jtSpmc);
        target.dataset.jtSpmd && (spmObj.buttonDesc = target.dataset.jtSpmd);
        target.dataset.jtSender && (spmObj.jtSender = target.dataset.jtSender);
        // 向上冒泡
        target = target.parentNode;
      }
      if (spmObj.jtSender) {
        const data = JSON.parse(spmObj.jtSender);
        // 优先使用业务参数data，其次spmObj
        const newSpmObj = {
          page_desc: spmObj.pageDesc,
          block_desc: spmObj.blockDesc,
          button_desc: spmObj.buttonDesc,
        };
        ctx.sendTracker({ ...newSpmObj, ...data });
      }
    } catch {}
  });
};

export const saveSessionStorage = (ctx: any, source: string) => {
  try {
    // TODO:添加关闭网页埋点
    const sessionStore = {
      ...ctx.sessionStore,
      startSource: ctx._mainObj.start_source,
      unloadSpm: getSpm(),
      unloadUrl: location.href,
    };
    sessionStorage.setItem('jimoTrackerSessionStore', JSON.stringify(sessionStore)); // 数据持久化
    if (ctx?._options?.enableLog) {
      console.log('%c[jimo-tracker-sdk]', consoleLogStyle, `set jimoTrackerSessionStore ${source}`, sessionStore);
    }
  } catch {}
};

/**
 * 监听浏览器关闭与刷新与location.href
 */
export const createWindowUnload = (ctx: any) => {
  try {
    window.addEventListener('unload', () => {
      saveSessionStorage(ctx, 'unload');
      window._jt_canPopstateTimer && clearTimeout(window._jt_canPopstateTimer);
    });
  } catch (error) {}
};

/**
 * 监听visibilitychange
 */
export const createDocumentVisibilityChange = (ctx: any) => {
  document.addEventListener('visibilitychange', () => {
    try {
      if (document.visibilityState === 'visible') {
        const subSessionId = getUuid();
        ctx._mainObj.sub_session_id = subSessionId;
        ctx.sessionStore.subSessionId = subSessionId;
        ctx.sendTracker({
          event_type: 'hot_start',
          block_desc: '',
          button_desc: 'pull_btn',
        } as JimoTrackerSdkData);
      } else if (document.visibilityState === 'hidden') {
        ctx.sendTracker({
          event_type: 'hot_quit',
          block_desc: '',
          button_desc: 'push_btn',
        } as JimoTrackerSdkData);
        saveSessionStorage(ctx, 'visibilityState:hidden');
      }
    } catch {}
  });
};
